export const MILLISECONDS_IN_A_SECOND = 1000;
export const SECONDS_IN_A_MINUTE = 60;
export const MILLISECONDS_IN_A_MINUTE = SECONDS_IN_A_MINUTE * MILLISECONDS_IN_A_SECOND;

/**
 * 5 Minutes
 */
export const THIRTY_SECONDS_IN_MS = 30 * MILLISECONDS_IN_A_SECOND;
